<script setup lang="ts">
import { useClassStore } from '../../../stores';
import CheckBox from '../../Form/CheckBox.vue';
import HandIcon from '../../../assets/icons/hand.svg';
import { computed } from 'vue';
import { ClassStudentInfo } from '../../../types/class';

const studentIds = defineModel<number[]>()

const classStore = useClassStore()

const students = computed(() => {
    const studentClone: ClassStudentInfo[] = JSON.parse(JSON.stringify(classStore.selectedClassDetails?.students?.filter(student => student.group_id) || []))
    const studentRaiseHandMap = new Map();
    classStore.raiseHandStudentIds.forEach((studentId, index) => studentRaiseHandMap.set(studentId, index));

    return studentClone.sort((a, b) => {
        const raiseHand1 = studentRaiseHandMap.has(a.id) ? studentRaiseHandMap.get(a.id) : Infinity;
        const raiseHand2 = studentRaiseHandMap.has(b.id) ? studentRaiseHandMap.get(b.id) : Infinity;

        return raiseHand1 - raiseHand2;
    });
})

</script>

<template>
    <label class="flex items-center gap-3 py-2 px-3 transition-all hover:bg-neutral-100 cursor-pointer text-blue-600 font-bold" v-for="student in students">
        <span>{{ student.full_name }}</span>
        <HandIcon v-if="classStore.raiseHandStudentIds.includes(student.id)" class="size-5" />
        <CheckBox v-model="studentIds" :value="student.id" class="ml-auto" />
    </label>
</template>